import { store } from '@/context/store';

// The vehicle body the applicant resolved during the journey, eg '4D WAGON'.
// bodyType normally lands in redux from a Glass's Guide response, reached
// through any of the existing call sites — the URL prefill for test-drive
// partners, returning-user restore, OCR, the quick-calculator's VIN-from-DB
// lookup, the form drill-down, and rego/plate lookup (see VehicleTypes.ts).
// It can also be hydrated straight from a saved application when a borrower
// resumes; the API drops the dealer-flow 'none' placeholder that path can
// carry in. Deliberately the body only: make, model, VIN, rego and stock
// number do not belong in tracking.
export type TrackingVehicle = { vehicleBodyType?: string };

// Mirrors the API cap.
const MAX_BODY_TYPE = 60;

export function getTrackingVehicle(): TrackingVehicle {
    try {
        const bodyType = (
            store.getState().borrowerReducer.vehicle.bodyType ?? ''
        ).trim();
        if (!bodyType || bodyType.length > MAX_BODY_TYPE) return {};

        return { vehicleBodyType: bodyType };
    } catch (error) {
        return {};
    }
}
